import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { tAccessPolicy, canAccess } from 'src/app/shared/classes/access-policy.class';

@Component({
  selector: 'index-page-button',
  templateUrl: './page-button.component.html',
  styleUrls: ['./page-button.component.css']
})
export class PageButtonComponent implements OnChanges {
  @Input()
  public link: string | string[];
  @Input()
  public title: string;
  @Input()
  private icon: string;
  @Input()
  public accessPolicy: tAccessPolicy;

  public sanitizedIcon: SafeUrl;
  public canActivate: boolean;
  public tooltip: string;
  public canAccess: boolean;

  constructor(private sanitizer: DomSanitizer, private auth: AuthService) {}

  ngOnChanges() {
    this.sanitizedIcon = this.sanitizer.bypassSecurityTrustStyle(`url(${this.icon})`);
    this.canAccess = !this.link ? false : canAccess(this.auth.userData.authorization, this.accessPolicy || true);
  }
}
